import { render, staticRenderFns } from "./zhuyuan.vue?vue&type=template&id=428ff384&scoped=true&"
import script from "./zhuyuan.vue?vue&type=script&lang=ts&"
export * from "./zhuyuan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428ff384",
  null
  
)

export default component.exports